<style lang="scss" src="./ProfileLinks.scss"></style>

<div class="profilelinks">
    <h3 class="profilelinks__title">About Originea</h3>
    <ul class="profilelinks__list">
        <li class="profilelinks__item">
            <a href="https://forms.gle/SJU1LseLgqY7aWDk9" target="_blank">Give feedback</a>
        </li>
        <li class="profilelinks__item">
            <a href="https://originea.xyz/" target="_blank">How it works</a>
        </li>
        <li class="profilelinks__item">
            <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank">Creative common license</a>
        </li>
        <li class="profilelinks__item">
            <a href="https://originea.xyz/privacy" target="_blank">Privacy policy</a>
        </li>
    </ul>
</div>